import { isProductAvailable } from '@app-types/product';
export const getProductVariant = (product, variantId) => product.variants?.find((variant) => variant.id === variantId);
export const resolveProductVariant = (product, variantId) => {
    if (!isProductAvailable(product))
        return undefined;
    if (!product.variants?.length)
        return variantId ? undefined : product;
    const variant = getProductVariant(product, variantId);
    return variant
        ? { ...product, priceMinor: variant.priceMinor, stripePaymentLink: variant.stripePaymentLink }
        : undefined;
};
export const getCartLineId = (productId, variantId) => variantId ? `${productId}:${variantId}` : productId;
